import {Tinode} from 'tinode-sdk';
import {sanitizeUrlForMime} from './utils.js';
export const STORY_LIFETIME = 24 * 60 * 60 * 1000;
export function activeStories(value, now = Date.now()) {
  if (!Array.isArray(value)) return [];
  return value.filter(row => row && typeof row.id === 'string' && Number.isFinite(row.createdAt) && Number.isFinite(row.expiresAt) && row.expiresAt > now && row.expiresAt <= row.createdAt + STORY_LIFETIME && ['image','video','text'].includes(row.type) && (row.type === 'text' ? typeof row.text === 'string' : !!sanitizeUrlForMime(row.ref,row.type === 'image'?'image':'video'))).slice(-8);
}
export async function saveStories(tinode, rows) {
  const me = tinode.getMeTopic();
  const pub = {...me.public, vibeStories: rows.length ? rows : Tinode.DEL_CHAR};
  const attachments = rows.filter(row => row.ref).map(row => row.ref);
  if (pub.photo?.ref) attachments.push(pub.photo.ref);
  await me.setMeta({desc:{public:pub}, attachments});
}
export function storyMediaURL(tinode, story) {
  return tinode.authorizeURL(sanitizeUrlForMime(story.ref,story.type === 'image'?'image':'video'));
}
